export default __webpack_public_path__ + "static/media/S_C_True.b298839a.jpg";